module.exports = __webpack_public_path__ + "img/overview.948a71c8.png";